// eslint-disable-next-line import/prefer-default-export
export const getBaseUrl = () => {
    const url = new URL(window.location.href);
    if (url.origin.endsWith("demo.adadot.com")) return "https://sit.adadot.com";
    return url.origin;
};

// eslint-disable-next-line import/prefer-default-export
export const getBaseWsUrl = () => {
    const url = new URL(window.location.href);
    if (url.origin.endsWith("demo.adadot.com")) return "https://sit.adadot.com";
    return url.origin.replace("https", "wss");
};
